import * as UserActions from './../actions/user_actions';
import extend from 'lodash/extend';
import * as SettingScreen from './../actions/settingScreen_actions';
import settingsScreen from '../components/settingsScreen/settingsScreen';

export var Setting = (state = {
    Changepassword: null, // Change password response
    ChangePasswordFaild: null,
    profileUpdate: null,
    verification: null,
    updateUserSelectedSecurityQuestionsStatus: null,
    StaffStatus: null,
    allSecurityQuestions: null,
    allRandomSecurityQuestions: null,
    otpResponseData: null,
    otpGetData: null
}, action) => {
    switch (action.type) {
        case "@@redux/INIT": {
        }
        case 'persist/REHYDRATE': {
            if (action.payload && action.payload.User) {
                action.payload.User.IsLoggingIn = false;
                return extend({}, state, action.payload.User);
            } else {
                return state;
            }
        }
        //otp
        case SettingScreen.SET_OTP_DATA : {

            return extend({}, state, { otpResponseData: action.data });

        } break;
        case SettingScreen.SET_OTP_GET_DATA: {
            
            
            return extend({}, state, { otpGetData: action.data });

        }break;

        case SettingScreen.RESET_OTP: {
            return extend({}, state, { otpResponseData: null, otpGetData: null })
        }break;

        case SettingScreen.CHANGE_PASSWORD_DATA: {
            return extend({}, state, { Changepassword: action.data });
        }
            break;

        case SettingScreen.CHANGE_PASSWORD_FAILD: {
            return extend({}, state, { ChangePasswordFaild: action.data });
        }
            break;
        case SettingScreen.PROFILE_UPDATE_DATA: {
            return extend({}, state, { profileUpdate: action.data });
        }
            break;
        case SettingScreen.PASSWORD_VERIFICATION_DATA: {
            return extend({}, state, { verification: action.data });
        }
            break;
        case SettingScreen.VERIFY_PASSWORD_FAILD: {
            return extend({}, state, { verification: action.data });
        }
            break;
        case SettingScreen.GET_SECURITY_QUESTIONS_DATA: {
            return extend({}, state, { SecurityAnswers: action.data });
        }
            break;
        case SettingScreen.GET_UPDATE_SECURITY_QUESTIONS_STATUS: {
            return extend({}, state, { updateUserSelectedSecurityQuestionsStatus: action.data });
        }
            break;
        case SettingScreen.UPDATE_STATUS_STAFF_PATIENT: {
            return extend({}, state, { StaffStatus: action.data });
        }
            break;
        case SettingScreen.ALL_SECURITY_QUESTIONS: {
            return extend({}, state, { allSecurityQuestions: action.data });
        }
            break;

        case SettingScreen.ALL_RANDOM_SECURITY_QUESTIONS: {
            return extend({}, state, { allRandomSecurityQuestions: action.data });
        }
            break;

        case UserActions.USER_LOG_OUT: {

            return extend({}, state, {
                Changepassword: null, // Change password response
                ChangePasswordFaild: null,
                profileUpdate: null,
                verification: null,
                updateUserSelectedSecurityQuestionsStatus: null,
                StaffStatus: null,
                allSecurityQuestions: null,
                allRandomSecurityQuestions: null,
            })
        }
            break;

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/setting_reducer.js
 **/